import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { signin, register } from "../redux/actions/usersAction";
import "../App.css";
import axios from "axios";
import { Redirect, useHistory, Link } from "react-router-dom";
import url from "src/constant/url";
import { usePost, postData } from "src/utils/useFetch";
import { useSnackbar } from "notistack";
import { Circles } from "react-loader-spinner";
import * as actionTypes from "../../src/redux/constants/usersConstant";

const LoginComp = (props) => {
  let history = useHistory();
  let dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const userSignin = useSelector((state) => state.userSignIn);
  let { userInfo, success, loading, error } = userSignin;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  const body = {
    email,
    password,
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    setShowLoader(true);

    await dispatch(signin(email, password));

    // await postData(`${url}/memberslogin`, body)
    //   .then((responses) => {
    //     console.log("responses", responses.result);
    //     setShowLoader(true);
    //     dispatch({
    //       type: actionTypes.USER_REGISTER_REQUEST,
    //     });
    //     if (responses.error && (responses.error.status == 400 || responses.error.data.error)) {
    //       setShowLoader(false);
    //       enqueueSnackbar(
    //         `${
    //           responses.error.data.error
    //             ? responses.error.data.error
    //             : "Network Error"
    //         }`,
    //         {
    //           variant: "error",
    //         }
    //       );
    //       dispatch({
    //         type: actionTypes.USER_REGISTER_FAIL,
    //       });
    //     } else {
    //       setShowLoader(false);
    //       dispatch({
    //         type: actionTypes.USER_SIGNIN_SUCCESS,
    //         payload: responses.result,
    //       });

    //       localStorage.setItem("userInfo", responses.result);
    //       // history.push("/dashboard");
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("err", err)
    //     setShowLoader(false);
    //     enqueueSnackbar(`Network Error`, { variant: "error" });
    //     dispatch({
    //       type: actionTypes.USER_REGISTER_FAIL,
    //     });
    //   });
  };
  useEffect(() => {
    if ((userInfo != undefined && Object.entries(userInfo).length > 0)) {
      setShowLoader(false);
      history.push("/dashboard");
    }

    if (error) {
      setShowLoader(false);
      enqueueSnackbar(`${error ? error : "Network Error"}`, {
        variant: "error",
      });
    }
    return () => {
      if (error) {
        localStorage.removeItem("userInfo");
        dispatch({
          type: actionTypes.USER_SIGNOUT,
        });
      }
    };
  }, [loading]);

  return (
    <>
      <section className="checkout-section spad" style={{ marginTop: "100px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-xl-3 col-sm-12"></div>

            <div className="col-lg-6 col-md-6 col-xl-6 col-sm-12 ">
              <div
                className="cf-title btn btn-lg regDiv"
                style={{
                  backgroundColor: "#006BA6",
                  width: "100%",
                  color: "white",
                }}
              >
                Membership Login
              </div>

              <form className="form" onSubmit={submitHandler}>
                <div className="cf-title" style={{ height: "30px" }}></div>

                <div className="row address-inputs form-group">
                  <div className="col-md-12">
                    <input
                      className="form-control"
                      type="email"
                      placeholder="Email"
                      required
                      style={{ marginBottom: "15px" }}
                      onChange={(e) => setEmail(e.target.value)}
                    />

                    <input
                      className="form-control"
                      type="password"
                      placeholder="Password"
                      required
                      style={{ marginBottom: "15px" }}
                      onChange={(e) => setPassword(e.target.value)}
                    />

                    <small>
                      Don't have an account ?
                      <Link to="/membersregister">Register</Link>
                    </small>
                    <br />

                    <button
                      className="form-control btn btn-primary"
                      type="submit"
                      style={{
                        backgroundColor: "#006BA6",
                        color: "white",
                        width: "100%",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ textAlign: "center", display: "flex" }}>
                        {showLoader && (
                          <Circles
                            type="Circles"
                            color="red"
                            height={30}
                            width={30}
                          />
                        )}
                        {!showLoader && "Login"}
                      </div>
                    </button>

                    {/* {false &&  <button
                      className="form-control btn btn-primary"
                      type="submit"
                      style={{
                        backgroundColor: "#006BA6",
                        color: "white",
                        width: "100%",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                      
                    >
                        <div style={{ textAlign: "center", display: "flex" }}>
                      {showLoader && (
                        <Circles
                          type="Circles"
                          color="red"
                          height={30}
                          width={30}
                        />
                      )}
                      {!showLoader && "Pay membership fee" }
                      

                    </div>
                    </button>} */}
                  </div>
                </div>
              </form>
            </div>

            <div className="col-lg-3 col-md-3 col-xl-3 col-sm-12"></div>
          </div>
        </div>
      </section>

      <div className="clear-fix" style={{ margin: "50px" }}></div>
      <div className="clear-fix" style={{ margin: "50px" }}></div>
      <div className="clear-fix" style={{ margin: "50px" }}></div>
    </>
  );
};

export default LoginComp;
